import {
  Box,
  Chip,
  CircularProgress,
  Divider,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';

import SearchIcon from '@mui/icons-material/Search';
import { getAllPlot } from 'rest_client/apiClient';

export default function SearchPlot({
  onSelect,
  placeholder,
  sx = {},
  reference,
  ...other
}) {
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [plotName, setIdPlot] = useState('');
  const [requesting, setRequesting] = useState(false);
  const onFocused = (e) => {
    setOpen(true);
  };
  const onChangeText = (txt) => {
    setIdPlot(txt);
  };

  const onGetAllPlot = async (txt) => {
    try {
      setRequesting(true);
      const response = await getAllPlot({
        idPlot: txt || plotName?.trim(),
        page: 1,
        perPage: 10,
      });
      if (response?.data) {
        setData(response?.data?.plots);
      }
      setRequesting(false);
    } catch (e) {
      setRequesting(false);
    }
  };
  const onSelectPlot = (plot) => {
    setOpen(false);
    onSelect(plot);
  };
  useEffect(() => {
    let typingTimer;
    const delay = 300;
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      onGetAllPlot(plotName);
    }, delay);
    return () => clearTimeout(typingTimer);
  }, [plotName]);
  useEffect(() => {
    const onClose = () => {
      setOpen(false);
    };
    document.addEventListener('click', onClose);
    if (reference) {
      reference.current = {
        onGetAllPlot,
      };
    }
    return () => document.removeEventListener('click', onClose);
  }, []);
  return (
    <Box
      {...other}
      sx={{
        position: 'relative',
        ...sx,
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <TextField
        placeholder={placeholder ? placeholder : 'Find plot name...'}
        fullWidth
        onFocus={onFocused}
        autoComplete="off"
        onChange={(e) => onChangeText(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: requesting && <CircularProgress size={20} />,
        }}
        sx={{
          borderRadius: '30px',
          background: '#F4F4F4',
          height: '40px',
          '& .MuiInputBase-root': {
            height: '40px',
          },
          '& fieldset': {
            borderRadius: '30px',
          },
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          maxHeight: '300px',
          overflow: 'auto',
          boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
          px: '12px',
          left: '20px',
          width: 'calc(100% - 40px)',
          display: open ? 'flex' : 'none',
          flexDirection: 'column',
          bgcolor: 'white',
          zIndex: 1,
        }}
      >
        {data?.map((i) => {
          return (
            <Box
              key={i.id}
              sx={{
                pt: '12px',
                cursor: 'pointer',
              }}
              onClick={(e) => {
                e.stopPropagation();
                onSelectPlot(i);
              }}
            >
              <Typography
                sx={{
                  fontWeight: 'bold',
                  fontSize: '14px',
                }}
              >
                Plot {i.name}
              </Typography>
              <Typography
                sx={{
                  fontWeight: '12px',
                  mt: '2px',
                  fontSize: '11px',
                }}
              >
                Location <strong>{i.placeName}</strong>
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  gap: '4px',
                  mt: '4px',
                }}
              >
                {Boolean(i.totalNeighbors || i.totalClaimants) && (
                  <Chip
                    label={
                      (i.totalClaimants
                        ? `${i.totalClaimants} Claimants`
                        : '') +
                      (i.totalNeighbors && i.totalClaimants ? ', ' : '') +
                      (i.totalNeighbors ? `${i.totalNeighbors} Neighbors` : '')
                    }
                    sx={{
                      bgcolor: 'rgba(94, 196, 172, 0.10)',
                      color: 'primary.main',
                      fontWeight: '600',
                      fontSize: '11px',
                    }}
                  />
                )}

                {Boolean(i.totalDisputes) && (
                  <Chip
                    label={i.totalDisputes + ' Disputed'}
                    sx={{
                      bgcolor: 'rgba(255, 185, 6, 0.10)',
                      color: '#FFB906',
                      fontWeight: '600',
                      fontSize: '11px',
                    }}
                  />
                )}
              </Box>

              <Divider sx={{ mt: '12px' }} />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
